const PREFETCH_LINKS = false;

Shopify = Shopify || {}
Shopify.theme = Shopify.theme || {}
/*************** DOM ***************/
Shopify.theme.dom = {
    init : function(){
        let that = this;
        this.calculateMainMinHeight()
        window.addEventListener('resize', (event) => {
            that.calculateMainMinHeight();
            document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
            document.querySelector(':root').style.setProperty('--vw', window.innerWidth/100 + 'px');
        })
        document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
        document.querySelector(':root').style.setProperty('--vw', window.innerWidth/100 + 'px');
        
        var has_videos = document.querySelector('external-video');
        if(has_videos != null){   
            let iframe_api = document.createElement('script');
            iframe_api.id = 'iframe_api';
            iframe_api.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(iframe_api);
        }

    },
    calculateMainMinHeight : function(){
        document.querySelector('main').style.minHeight = 'calc(100vh - ' + document.querySelector('header').offsetHeight + 'px - ' + document.querySelector('footer').offsetHeight +'px)'
    }
};
Shopify.theme.dom.init();
/*************** LINKS ***************/
Shopify.theme.links = {
    init : function(){
        Shopify.theme.links.scrollToView();
        window.onload = function(){
            setTimeout(function(){
                Shopify.theme.links.prefetchLinks();
            }, 10000);
        }
    },
    /*************** SCROLL TO VIEW ***************/
    scrollToView : function(){
        document.querySelectorAll('a').forEach(
            element => {
                if (!element.href) return;
                let url = new URL(element.href)
                if(url.hash != '' && url.pathname == location.pathname){
                    element.addEventListener('click',function(event){
                        event.preventDefault()
                        window.scrollTo(0,document.querySelector(url.hash).offsetTop)
                    })
                }
            }
        )
        window.addEventListener('load',function(){
            if(location.hash != ''){
                let url = location;
                window.scrollTo(0,document.querySelector(url.hash).offsetTop)
                history.replaceState({}, document.title, window.location.pathname + window.location.search);
            }
        })
    },
    /*************** PREFETCH LINKS ***************/
    prefetchLinks : function(){
        if ( PREFETCH_LINKS ) {
            var [ arrayNewPrefetch, newPrefetch ] = [ [] ];
            Array.from( document.querySelectorAll('a') ).forEach(element => {
                if (!element.href.includes('#') && !element.href.includes('mailto:') && element.href !== 'javascript:void(0);' && element.href !== 'javascript:void(0)' && element.href !== '' ) {
                    if( arrayNewPrefetch.includes( element.href ) === false ) {
                        newPrefetch = document.createElement('link');
                        newPrefetch.rel = "prefetch";
                        newPrefetch.href = element.href;
                        document.head.appendChild(newPrefetch);
                        arrayNewPrefetch.push( element.href );
                    }
                }
            })
        }
    }
}
Shopify.theme.links.init();
/*************** TOOLS ***************/
Shopify.theme.tools = {
    handleize: function(value){
        let handle =  value.toString().split(' ').join('-');
        handle = handle.toLowerCase();
        return handle
    },
    formatMoney: function (cents, format){
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let money_format = format;
        switch(money_format.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 2, "'", ".");
                break;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = (typeof precision != 'undefined' ? precision : 2);
            thousands = (typeof thousands != 'undefined' ? thousands : ".");
            decimal   = (typeof decimal != 'undefined' ? decimal : ",");

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.');
            let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            let cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }
        return money_format.replace(placeholderRegex, value)
    },
    /*************** SHOPIFY COMMON.JS (PROVINCE SELECTOR) ***************/
    bind: function(t,e){
        return function(){
          return t.apply(e,arguments)
        }
    },
    setSelectorByValue: function(t,e){
        for(var n=0,i=t.options.length;n<i;n++)
        {
            var o=t.options[n];
            if(e==o.value||e==o.innerHTML)
                return t.selectedIndex=n
        }
    },
    postLink: function(t,e){
        var n = ( e = e || {}).method || "post";
        i = e.parameters || {};
        o = document.createElement("form");
        for(var r in o.setAttribute("method", n),o.setAttribute("action",t),i){
            var l = document.createElement("input");
            l.setAttribute("type","hidden");
            l.setAttribute("name",r);
            l.setAttribute("value",i[r]);
            o.appendChild(l)
        }
        document.body.appendChild(o);
        o.submit();
        document.body.removeChild(o);
    },
    setClassToRichtext : function (classString, selectorElement){
        //console.log("----> setClassToRichtext: ",classString," ",selectorElement);
        var el = document.querySelectorAll(selectorElement + " p").forEach((elem) => {
            //console.log("   internal p:", elem)
            elem.classList.add(classString);
        });
        var el_a = document.querySelectorAll(selectorElement + " a").forEach((elem) => {
            elem.classList.add(classString);
            //console.log("   internal a:", elem)
        });
    }
}

Shopify.theme.tools.CountryProvinceSelector = function(t,e,n){
    this.countryEl = document.getElementById(t);
    this.provinceEl = document.getElementById(e);
    this.provinceContainer = document.getElementById(n.hideElement||e);
    this.countryEl.addEventListener('change', Shopify.theme.tools.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince();
}

Shopify.theme.tools.CountryProvinceSelector.prototype = {
    initCountry: function(){
        var t = this.countryEl.getAttribute("data-default");
        Shopify.theme.tools.setSelectorByValue(this.countryEl,t);
        this.countryHandler();
    },
    initProvince: function(){
        var t=this.provinceEl.getAttribute("data-default");
        t && 0 < this.provinceEl.options.length && Shopify.theme.tools.setSelectorByValue(this.provinceEl,t);
    },
    countryHandler: function(){
        var t=(i=this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces");
        e=JSON.parse(t);
        if(this.clearOptions(this.provinceEl),e&&0==e.length)
            this.provinceContainer.style.display="none";
        else{
            for(var n=0;n<e.length;n++){
                var i;(i=document.createElement("option")).value=e[n][0];
                i.innerHTML=e[n][1],this.provinceEl.appendChild(i);
            }
            this.provinceContainer.style.display = "";
        }
    },
    clearOptions: function(t){
        for(;t.firstChild;)
            t.removeChild(t.firstChild);
    },
    setOptions: function(t,e){
        var n=0;
        for(e.length;n<e.length;n++){
            var i=document.createElement("option");
            i.value = e[n];
            i.innerHTML = e[n];
            t.appendChild(i);
        }
    }
}

Shopify.currency.moneyFormat = null;
/*************** CART ***************/
Shopify.theme.cart = {
    init : function(){
        let that = this;
    },
    addToCart : function (addData) {
        /** HOTFIX sometimes grid items are not sending variant id **/
        if (typeof addData.items === "object") {
            let missing_id = false
            addData.items.forEach(item => {
                if (typeof item.id == "undefined") {
                    missing_id = true;
                }
            });
            if (missing_id) {
                return false;
            }
        }
        /** END HOTFIX **/

        /*
        // Prüfung ob Ursprung von einem Abo AddToCart ist. ### Fix für Safari...
        if (
            !!arguments &&
            !!arguments.callee &&
            !!arguments.callee.caller &&
            !!arguments.callee.caller.arguments[0] &&
            !!arguments.callee.caller.arguments[0].target &&
            !!arguments.callee.caller.arguments[0].target.getAttribute('is_abo')
        ) {
            addData["items"][0]["selling_plan"] = arguments.callee.caller.arguments[0].target.getAttribute('is_abo');
        } else if(
            !!arguments &&
            !!arguments.callee &&
            !!arguments.callee.caller &&
            !!arguments.callee.caller.caller &&
            !!arguments.callee.caller.caller.arguments[0] &&
            !!arguments.callee.caller.caller.arguments[0].target &&
            !!arguments.callee.caller.caller.arguments[0].target.getAttribute('is_abo')
        ) {
            addData["items"][0]["selling_plan"] = arguments.callee.caller.caller.arguments[0].target.getAttribute('is_abo');
        }
    */
        
        fetch(`${routes.cart_url}/add.js`, {
                body: JSON.stringify(addData),
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
                method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                    })
                } else {
                   return response.json();
                }   
            }).then(function(data) {
                let items = data.items;
                let addevent = new CustomEvent("cartadd", {detail:{items}});
                window.dispatchEvent(addevent);
                Shopify.theme.cart.getCart()        // Added as a Quickfix for updating the cart, when a product is added from an upsell section (i.e. index_ft_card_products.liquid)
            }).catch(function(err) {
                console.error(err);
            }
        );
    },
    getCart: function (){
        fetch(`${routes.cart_url}.js`, {
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'GET'
            }).then(function(response) {
                return response.json();
            }).then(function(cart) {
                let event = new CustomEvent("cartdatachanged", {detail:{cart}});
                window.dispatchEvent(event);
            }).catch(function(err) {
                console.error(err)
            });
    },
    // Example input: { updates: { 12345678: 2, 87654321: 3 } }
    updateCart: function (itemsToUpdate){
        fetch(`${routes.cart_url}/update.js`, {
            body: JSON.stringify(itemsToUpdate),
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
        }).then(function(response) {
            if(!response.ok) {
                response.text().then(text => {
                    let error = JSON.parse(text);
                    console.error(error.status);
                    console.error(error.message);
                    console.error(error.description);
                })
            } else {
               return response.json();
            }   
        }).then(function(cart) {
            let event = new CustomEvent("cartdatachanged", {detail:{cart}});
            window.dispatchEvent(event);
        }).catch(function(err) {
            console.error(err)
        });
    },
    clearCart: function (){
        fetch(`${routes.cart_url}/clear.js`, {
            body: '',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                    })
                } else {
                   return response.json();
                }   
            }).then(function(cart) {
                let event = new CustomEvent("cartdatachanged", {detail:{cart}});
                window.dispatchEvent(event);
            }).catch(function(err) {
                console.error(err)
            });
    },
    // Example input: { 'id': 794864053, 'quantity': 3 }
    changeItem: function (itemToChange){
        fetch(`${routes.cart_url}/change.js`, {
            body:  JSON.stringify(itemToChange),
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                    })
                } else {
                    return response.json();
                }   
            }).then(function(cart) {
                for (const item of cart.items) {
                    if(item.key == itemToChange.id && item.quantity != itemToChange.quantity)
                        console.error("inventory_quantity reached old quantity remains!");
                }
                let event = new CustomEvent("cartdatachanged", {detail:{cart}});
                window.dispatchEvent(event);
            }).catch(function(err) {
                console.error(err)
            });
    }
};
Shopify.theme.cart.init();


/* Custom Components */
/* External Video */
function VideoControls() {
    return Reflect.construct(HTMLElement, [], this.constructor);
}
VideoControls.prototype = Object.create(HTMLElement.prototype);
VideoControls.prototype.constructor = VideoControls;
Object.setPrototypeOf(VideoControls, HTMLElement);
VideoControls.prototype.connectedCallback = function() {
    var that = this;
    if(that.hasAttribute('for')){
        that.for = document.querySelector('#'+that.getAttribute('for'));
        that.addEventListener('click',function(){
            that.for.toggleVideo();
        })
    }
};
customElements.define('video-controls', VideoControls);



function ExternalVideo() {
    return Reflect.construct(HTMLElement, [], this.constructor);
}
ExternalVideo.prototype = Object.create(HTMLElement.prototype);
ExternalVideo.prototype.constructor = ExternalVideo;
Object.setPrototypeOf(ExternalVideo, HTMLElement);
ExternalVideo.prototype.connectedCallback = function() {
    let that = this;
    this.setAttribute('state', 'idle');
};
ExternalVideo.prototype.toggleVideo = function(){
    let that = this;
    if(that.getAttribute('state') == 'idle')
        that.loadVideo();
    else if(that.getAttribute('state') == 'play')
        that.pauseVideo();
    else    
        that.playVideo();
}
ExternalVideo.prototype.loadVideo = function(){
    let that = this;
    this.setAttribute('state', 'load')
    that.youtube_player = new YT.Player(that.querySelector('.iframe_placeholder') , {
        width: '100%',
        height: '100%',
        videoId: that.getAttribute('video-id'),
        autoplay: 1,
        enablejsapi: 1,
        showinfo: 0,
        origin: 'https://clever-2-0.myshopify.com',
        playerVars: {
            origin: 'https://clever-2-0.myshopify.com',
            iv_load_policy: 3,
            modestbranding: 1,
            controls: 0,
            playsinline: 1,
            showinfo: 0,
            playlist: that.getAttribute('video-id'),
            loop: 0,
            mute: 0
        },
        events: {
            'onReady': that.playVideo.bind(that)
        }
    });
};
ExternalVideo.prototype.playVideo = function(){
    this.youtube_player.playVideo();
    this.setAttribute('state', 'play')
};
ExternalVideo.prototype.pauseVideo = function(){
    this.youtube_player.pauseVideo();
    this.setAttribute('state', 'pause')
};
customElements.define('external-video', ExternalVideo);


function CleverSelect() {
    return Reflect.construct(HTMLElement, [], this.constructor);
}

CleverSelect.prototype = Object.create(HTMLElement.prototype);
CleverSelect.prototype.constructor = CleverSelect;
Object.setPrototypeOf(CleverSelect, HTMLElement);

CleverSelect.prototype.connectedCallback = function() {
    this.init()
    this.toggleDropdown()
};

CleverSelect.prototype.toggleDropdown = function() {
    this.shadow_list.classList.toggle('hidden');
    this.shadow_button.classList.toggle('open');
};

CleverSelect.prototype.closeDropdown = function() {
    this.shadow_list.classList.add('hidden');
    this.shadow_button.classList.remove('open');
};

CleverSelect.prototype.init = function() {
    var that = this;

    this.observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            that.renderShadowDOM();
        });
    });

    this.observer_config = { attributes: true, childList: true, characterData: true, subtree: true };

    this.shadow_root = this.attachShadow({ mode: 'open' });

    this.renderShadowDOM();

};

CleverSelect.prototype.renderShadowDOM = function(){
    var that = this;
    this.options = this.querySelectorAll('option');
    this.btn_class = this.dataset.btnclass;

    this.observer.disconnect();
    
    this.shadow_root.innerHTML = `
        <link rel="stylesheet" href="//loewenzahnorganics.com/cdn/shop/t/199/assets/clever-select.css?v=62664409482507293931764661554">
        <button class="`+this.btn_class+` open"><output></output>

<svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 20 20"><path d="M5 8l5 5 5-5H5z"></path></svg>
<!--<svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 20 20"><path d="M14 20.001a.994.994 0 01-.747-.336l-8-9a.999.999 0 010-1.328l8-9a1 1 0 011.494 1.328l-7.41 8.336 7.41 8.336A.998.998 0 0114 20.001z"></path></svg>
-->
</button>
        <ul class="">
        </ul>
    `;
    this.shadow_button = this.shadow_root.querySelector('button');
    this.shadow_output = this.shadow_root.querySelector('output');
    this.shadow_list = this.shadow_root.querySelector('ul')
    this.options.forEach(option => {
        var li = document.createElement('li');
        li.innerHTML = option.innerHTML;
        if(option.hasAttribute('disabled')){
            li.setAttribute('disabled','')
        }
        else{
            li.addEventListener('click',function(){
                that.shadow_output.innerHTML =  option.innerHTML;
                that.setAttribute("value", option.getAttribute('value'))
                that.options.forEach(o => {
                    o.removeAttribute('selected');
                })
                option.setAttribute('selected','')
                that.closeDropdown();
                that.dispatchEvent(new Event('change'))
            })
        }
        if(option.hasAttribute('selected')){
            that.shadow_output.innerHTML =  option.innerHTML;
            that.setAttribute("value", option.getAttribute('value'))
        }
        that.shadow_list.appendChild(li)
    })

    this.shadow_button.addEventListener('click',function(){
        that.toggleDropdown();
    })

    document.body.addEventListener('click',function(e){
        if(!that.shadow_root.contains(e.composedPath()[0])){
            that.closeDropdown();
        }
    })

    this.observer.observe(that, that.observer_config);
}

CleverSelect.prototype.disconnectedCallback = function() {
    this.observer.disconnect();
}

customElements.define('clever-select', CleverSelect);


  
    var aos_script = document.createElement('script')
    aos_script.id = "AOS"
    aos_script.src = "//loewenzahnorganics.com/cdn/shop/t/199/assets/aos.js?v=137969130111557957861764661553" 
    document.head.appendChild(aos_script)

    var aos_styles = document.createElement('link')
    aos_styles.setAttribute('rel', 'stylesheet');
    aos_styles.setAttribute('type', 'text/css');
    aos_styles.setAttribute('href', "//loewenzahnorganics.com/cdn/shop/t/199/assets/aos.css?v=171440860698160758581764661552");
    document.head.appendChild(aos_styles)

    document.querySelector('#AOS').addEventListener('load',function(){
        AOS.init();
    })



document.addEventListener("DOMContentLoaded", function() {
    let loopIndex = 0;
    zendeskApp(loopIndex, false)
})
function zendeskApp(loopIndex, repeated_try) {
    try {
        console.log('Reconfigure zendesk start');
        zE('webWidget', 'updateSettings', {
            webWidget: 
            {
                launcher: 
                {
                    label: 
                    {
                        '*': 'Frage?'
                    },
                    chatLabel: {
                        '*': 'Chat'
                    },
                    mobile: 
                    {
                        labelVisible: true
                    }
                },
                contactOptions: {
                    enabled: true,
                },
                chat: 
                {
                    title: 
                    {
                        '*': 'Chatte mit uns'
                    },
                    offlineForm: 
                    {
                        greeting:
                        {
                            '*': 'Wir sind momentan nicht online. Hinterlasse eine Nachricht. Wir werden uns in Kürze bei dir melden.',
                        }
                    }
                }
            }
        });
        console.log('Reconfigure zendesk done');
    } catch(e){
        console.log('Not found zendesk');
        let i = loopIndex + 1;
        if( i < 3)
        {
            setTimeout(zendeskApp( i, false ), 2000);  
        }
        if( i >= 3 && !(repeated_try) )
        {
            console.log('Recalling zendesk widget');
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'ze-snippet';
            script.src = 'https://static.zdassets.com/ekr/snippet.js?key=8a82ccfd-95c3-4b3a-a544-18fad407742f';
            document.getElementsByTagName('head')[0].appendChild(script);

            createZendeskObserver("body");
            
        }

    }
}


function zendeskMutate(mutationList, observer) {
    mutationList.forEach( (mutation) => {
        mutation.addedNodes.forEach( (node) => {
            if (typeof node.querySelector != "undefined") {
                let target = node.querySelector("#launcher");
                if (!!target)
                {
                    observer.disconnect();
                    zendeskApp( 3, true);
                }
            }

        })
    })
        
}


function createZendeskObserver(zendesk_selector) {

    const targetNode = document.querySelector(zendesk_selector);
    const observerOptions = { childList: true }

    const observer = new MutationObserver(zendeskMutate);
    observer.observe(targetNode, observerOptions);

}